import { defineStore } from 'pinia'

function defaultState() {
  return {
    contractState: null,
  }
}

export const useContractStore = defineStore('contract', {
  state: () => {
    const saved = sessionStorage.getItem('contract')
    const persisted = saved ? JSON.parse(saved) : {}
    return { ...defaultState(), ...persisted }
  },

  getters: {
    activeContracts(state) {
      if (state.contractState) return state.contractState.contracts
      return []
    },
    activeProposals(state) {
      if (state.contractState) return state.contractState.proposals
      return []
    },
    boundPlayerIds() {
      return new Set(
        this.activeContracts
          .flatMap(c => [c.proposer, c.speaker])
          .filter(id => id != null)
      )
    },
  },

  actions: {
    saveContractState(payload) {
      this.contractState = payload
    },

    reset() {
      this.$patch(defaultState())
    },
  },
})
